export default class ChatMessageModel {
  constructor () {
    this.sender = {
      type: '',
      name: '',
      photo: '',
    }
    this.id = ''
    this.content = ''
    this.type = ''
    this.timestamp = ''
  }

  static fromJSON (json) {
    let chat = new ChatMessageModel()
    chat.sender = json.sender
    chat.id = json.id
    chat.content = json.content
    chat.type = json.type
    chat.timestamp = json.timestamp
    return chat
  }
}
